import type { Document } from '@src/orders/domain/PermitApplication';
import type { SelfIssuedGeneratePdfFields } from '@src/permits/completePermit/fields/SelfIssuedGeneratePdfFields';
import { PermitApplicationClient } from '@src/permits/services/PermitApplicationClient';
import { useMutation } from '@tanstack/react-query';

interface Props {
  permitApplicationId: string;
  onSuccess: (newDocument: Document) => void;
  onError: () => void;
}

export const useGenerateSelfIssuedPdf = ({
  permitApplicationId,
  onSuccess,
  onError,
}: Props) => {
  const { mutate: generateSelfIssuedPdf, isPending: isPDFGenerationPending } =
    useMutation({
      mutationFn: async (requiredPdfInfos: SelfIssuedGeneratePdfFields) => {
        return await PermitApplicationClient.generateSelfIssuedPdf({
          permitApplicationId,
          fields: requiredPdfInfos,
        });
      },
      onSuccess,
      onError,
    });

  return { generateSelfIssuedPdf, isPDFGenerationPending };
};
